"use strict";

import { _t } from "@/tools/Utils";

export default [
  {
    path: "/panel/dashboard",
    name: "dashboard",
    component: () => import("@/packages/dashboard/layout/Dashboard.layout.vue"),
    redirect: { name: "dashboard.main" },
    meta: {
      title: _t("public.router_title.index"),
      requiresAuth: true,
    },
    children: [
      {
        path: "/panel/dashboard/index",
        name: "dashboard.main",
        component: () => import("@/packages/dashboard/views/Dashboard.vue"),
        meta: {
          title: "پنل",
          requiresAuth: true,
        },
      },
      {
        path: "/panel/dashboard/certificates",
        name: "dashboard.certs",
        component: () => import("@/packages/dashboard/views/Certificate.vue"),
        meta: {
          title: "مدرک ها",
          requiresAuth: true,
        },
      },
      {
        path: "/panel/dashboard/certificate/edit/:id",
        name: "dashboard.cert.edit",
        component: () => import("@/packages/dashboard/views/Certificate.vue"),
        meta: {
          title: "تغییر مدرک",
          requiresAuth: true,
        },
      },
      {
        path: "/panel/dashboard/profile",
        name: "dashboard.profile",
        component: () => import("@/packages/dashboard/views/Profile.vue"),
        meta: {
          title: "پروفایل",
          requiresAuth: true,
        },
      },
    ],
  },
];
